import { useMemo } from "react";
import Filter from "./Filter";
import { useFilters } from "../../../../utils/hooks/useFilters";
import { useDefaultConfig } from "./useDefaultConfig";

function QuickFilters({ config }: any) {
    const defaultConfig = useDefaultConfig();
    const [filters] = useFilters();

    const _config = useMemo(() => {
        if (config?.length > 0) {
            return config;
        } else {
            return defaultConfig;
        }
    }, [config, defaultConfig]);

    return (
        <div className="tw-flex tw-items-center tw-gap-2">
            {_config.map((filter: any) => {
                const exist = filters?.filters?.find((item: any) => item.name === filter.key);

                return (
                    <Filter
                        key={filter.key}
                        label={filter.label}
                        url={filter.url}
                        getSearchFilters={filter?.getSearchFilters}
                        value={exist?.value?.map((item: string) => typeof item === "string" ? ({ id: item }) : item)}
                        filterKey={filter.key}
                        method={exist?.method}
                    />
                )
            })}
        </div>
    );
}

export default QuickFilters;
